import { render } from "./dataComponent.vue?vue&type=template&id=3a313c5e"
import script from "./dataComponent.vue?vue&type=script&lang=js"
export * from "./dataComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sendi\\.tools\\sources\\SendiNewClient2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__